<script>
import Layout from '../../layouts/main'
import PageHeader from '@/components/page-header'
import appConfig from "@/app.config";

export default {
   page: {
      title: "Product Details",
      meta: [
         {
            name: "description",
            content: appConfig.description,
         },
      ],
   },
   components: { Layout, PageHeader },
   data() {
      return {
         title: "Product Details",
         items: [
            {
               text: "Products",
               href: "/products",
            },

            {
               text: "Details",
               active: true,
            },
         ],
         product: [],
        
      };
   },
   mounted() {

   },
   created() {
         this.fetchProduct();
      },

   methods: {
      fetchProduct() {

         this.getToken();
         let url = "api/product/details?id=" + this.$route.params.id;          
         this.loading = true;

         this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               if(res.status == 200) {
                  var responseData = res.data.data;
                  console.log(responseData);
                  this.product = responseData.product;
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            
         })
         .catch((error) => {
            if (error.response) {
               if(error.response.status == 422) {               
                  if (error.response.data) {
                     this.errors = error.response.data.message;
                  } 
                  this.$swal("", error.response.statusText, "error");
                  
               } else if(error.response.status == 500) {
                  this.$swal("", error.response.statusText, "error");

               } else if(error.response.status == 401) {
                  this.$swal("", error.response.statusText, "error");
                  this.$router.push({ name: "login" });
                  
               } else {
                  this.$swal("", "Something went wrong", "error");
               }
            } else {
               this.$swal("", error.message, "error");
            }
         })
         .finally(() => (this.loading = false));
         }, 
         getToken() {
         if (localStorage.getItem('sigofish_admin')) {
            var sigofish_admin =  JSON.parse(localStorage.getItem('sigofish_admin'));
            if(sigofish_admin.token) {
               this.token = sigofish_admin.token;
            } else {
               this.$swal("", "Failed to fetch token, please login again", "error");
               this.$router.push({ name: "login" });
            }
            
         } else {
            this.$swal("", "Session expired, please login again", "error");
            this.$router.push({ name: "login" });
         }
         }, 
      showModal(modal) {
         this.$refs[modal].show();
      },

      hideModal(modal) {
         this.$refs[modal].hide();
      },
   }
}
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-3">
                     <div class="col-12">

                        <a href="#" @click.prevent="$router.go(-1)" class="btn btn-primary float-end"><i
                              class='bx bx-chevrons-left'></i> Back</a>

                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!---- Details starts -------->
                  <div class="row">
                     

                   

                     <div class="col-lg-7">
        <div class="card">
          <div class="card-body">
            <div class="d-flex">
              <!-- <img src="@/assets/images/users/squid.png" alt class="avatar-sm me-4" /> -->
              
                   <img v-if="product.image" :src="$image_url + product.image" alt
                            class="avatar-sm me-4">
                           <img v-else src="@/assets/images/no-image.png"
                              alt
                              class="avatar-sm me-4"
                              />
                                    
              <div class="flex-grow-1 overflow-hidden">
                <h5 class="text-truncate font-size-15">{{product.name}}</h5>
                <p class="text-muted"></p>
              </div>
            </div>

            <h5 class="font-size-15 mt-4">Description :</h5>

            <p class="text-muted">
               {{product.description}}</p>

            <h5 class="font-size-15 mt-4">Storage Instruction :</h5>

            <p
            class="text-muted">
            {{product.storage_instructions}}</p>
                        <!-- <div class="text-muted mt-4">
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> To achieve this, it would be necessary
              </p>
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> Separate existence is a myth.
              </p>
              <p>
                <i class="mdi mdi-chevron-right text-primary me-1"></i> If several languages coalesce
              </p>
            </div> -->

            <!-- <div class="row task-dates">
              <div class="col-sm-4 col-6">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar me-1 text-primary"></i> Start Date
                  </h5>
                  <p class="text-muted mb-0">08 Sept, 2019</p>
                </div>
              </div>

              <div class="col-sm-4 col-6">
                <div class="mt-4">
                  <h5 class="font-size-14">
                    <i class="bx bx-calendar-check me-1 text-primary"></i> Due Date
                  </h5>
                  <p class="text-muted mb-0">12 Oct, 2019</p>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </div>
        <div class="col-lg-5">
                        <b-card header-class="bg-transparent border-light" class="border border-light">
                           <h4
                              class="font-size-16 bg-light  border border-top-0 border-start-0 border-end-0 px-3 py-2 mb-3">
                              Other Details</h4>


                           <div class="table-responsive ">
                              <table class="table table-nowrap mb-0">
                                 <tbody>

                                    <tr width="50%">
                                       <th scope="row">Price</th>
                                       <th>:</th>
                                        <td>RS.{{product.price}}</td>

                                    </tr>


                                   <!--  <tr width="50%">
                                       <th scope="row">Serves</th>
                                       <th>:</th>
                                       <td>{{product.serves}}</td>
                                    </tr>
 -->
                                    <tr width="50%">
                                       <th scope="row">Category</th>
                                       <th>:</th>
                                       <td><span v-if="product.category">{{product.category.name}}</span></td>
                                    </tr>

                                    <tr width="50%">
                                       <th scope="row">Sub Category</th>
                                       <th>:</th>
                                       <td><span v-if="product.sub_category"> {{product.sub_category.name}}</span></td>
                                    </tr>

                                    <tr>
                                       <th scope="row">Created On</th>
                                       <th>:</th>
                                       <td>{{product.converted_created_at }}</td>
                                    </tr>

                                    <tr>
                                       <th scope="row">Updated On</th>
                                       <th>:</th>
                                       <td>{{product.converted_updated_at }}</td>
                                    </tr>

                                 </tbody>
                              </table>
                           </div>

                        </b-card>
                        <!-- end card -->
                     </div>               



                     <!-- </div> -->

                  </div>
                  <!---- Details ends -------->

               </div>
            </div>
         </div>
      </div>

      <!---- modal starts ---->
      <!-- <b-modal ref="password-modal" id="password-modal" title="Change Password" hide-footer @hidden="clearForm()">
         <b-form @submit.prevent="changePassword()">
            <b-row>
               <b-col lg="12" class="form-group">
                  <label class="control-label">New Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password"></b-form-input>


               </b-col>

               <b-col lg="12" class="form-group">
                  <label class="control-label">Confirm Password<span class="text-danger">*</span></label>
                  <b-form-input type="password" v-model="password_confirmation"></b-form-input>


               </b-col>

               <b-col lg="12">
                  <b-button type="submit" class="me-3" variant="primary">Save</b-button>
                  <b-button class="" variant="light" @click="hideModal('password-modal')">Close</b-button>
               </b-col>
            </b-row>
         </b-form>
      </b-modal> -->
      <!---- modal ends ----->

   </Layout>
</template>
